import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Holiday } from '../entities/holiday';
import { DepartmentService } from './department.service';
import { Department } from '../entities/department';
import { Observable } from 'rxjs';
import { ResponsePageable } from 'app/shared/_utils/services/responsePageable';

@Injectable()
export class HolidayService extends BaseCrudService<Holiday> {

  public uri = '/api/holiday/';
  
  constructor(
    injector: Injector,
    private departmentService: DepartmentService) {
    super(injector);
    //console.log('Instance HolidayService');
  }

  loadDepartments(udepartment: Department): Observable<ResponsePageable<Department>> {
    const department = new Department();
    //department.country = ubigeo.country;
    return this.departmentService.search(department);
  }

  buildSentence(entity?: Holiday, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.date ?
          `date${QueryOperator.Equal}${entity.date}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasCompensation ?
          `hasCompensation${QueryOperator.Equal}${entity.hasCompensation}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.compensationStart ?
          `compensationStart${QueryOperator.Equal}${entity.compensationStart}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.compensationEnd ?
          `compensationEnd${QueryOperator.Equal}${entity.compensationEnd}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.locationHoliday && entity.locationHoliday.id) {
        query = query.concat(
          `locationHoliday.id${QueryOperator.Equal}${entity.locationHoliday.id}${QueryOperator.Split}`
        );
      }
      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      if (entity && entity.executingUnit) {
        query = query.concat(
          entity.executingUnit.id ? 'executingUnit.id'
            + QueryOperator.Equal + entity.executingUnit.id
            + QueryOperator.Split : QueryOperator.Empty
        );
      }
      query = query.concat(
        entity.compensationAdditional ?
          `compensationAdditional${QueryOperator.Contain}${entity.compensationAdditional}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/holiday.service.ts